import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import {
  mutations
} from './mutations'

Vue.use(Vuex)
// const debug = process.env.NODE_ENV !== 'production'
const initialState = {
  latestHour: '',
  earliestHour: '',
  redirectionUrlAfterLogin: 'Agenda',
  vorigSchermActiveren: true,
  cursistInfo: {},
  currentOpleiding: {},
  opleidingList: [],
  gevolgdeopleidingOpleidingList: [],
  moduleList: [],
  participationList: [],
  participationListCalendar: [],
  betalingenInfo: [],
  accountInformation: {
    fullname: '',
    gebruikersnaam: '',
    lastlogin: '',
    gebruikersnummer: ''

  },
}
const state = JSON.parse(JSON.stringify(initialState))
state.initialValues = JSON.parse(JSON.stringify(initialState))
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
